import type { SponsorPlanItem } from '@app/_proto/Protos/sponsors';
import ChampionBenefitBoxCustom from '@app/domains/champion/components/ChampionBenefitBoxCustom';
import ChampionPlanPriceInfo from '@app/domains/champion/components/ChampionPlanPriceInfo';
import GradationButton from '@app/domains/common/components/button/GradationButton';
import { decimalToNumber } from '@app/libs/utils';

type Props = {
    on?: string;
    novelName: string;
    championPlan: SponsorPlanItem;
    onClickMore: () => void;
    onClickSubscribe: (plan: SponsorPlanItem) => void;
};

export default function ChampionBenefitDialogPanel({ novelName, championPlan, onClickMore, onClickSubscribe }: Props) {
    const { advanceChapterCount, price } = championPlan;
    return (
        <div className="text-center">
            <div className="mb-4">
                <img className="inline-block w-140" src="/images/champion-logo@3x.png" alt="champion-logo" />
            </div>
            <div className="mb-12 md:mb-16">
                <h2 className="font-set-b26 text-gray-t1">{novelName}</h2>
            </div>
            <div className="mb-24 md:mb-28">
                <p className="font-set-r16 whitespace-pre-line px-8 text-gray-t2">
                    {'Become a Champion and read all published chapters for free!\nNo more waiting!'}
                </p>
            </div>
            <div className="mb-28 px-8">
                <ChampionBenefitBoxCustom advanceChapterCount={advanceChapterCount} />
            </div>
            <div className="mb-25">
                <GradationButton
                    className="block w-full rounded-12 px-20 py-10"
                    disabled={!championPlan.enabled}
                    onClick={() => {
                        onClickSubscribe(championPlan);
                    }}
                >
                    <div className="flex flex-col">
                        <div className="font-set-b16 text-white">
                            {championPlan.enabled ? 'SUBSCRIBE' : 'UNAVAILABLE'}
                        </div>
                        <div className="font-set-sb12 text-white/70">
                            <ChampionPlanPriceInfo
                                price={decimalToNumber(price)}
                                discountInfo={championPlan.discountInfo}
                                withDiscountDurationWarning={true}
                                priceProps={{
                                    className: '',
                                }}
                                discountedPriceProps={{
                                    className: '',
                                }}
                                durationProps={{
                                    className: '',
                                }}
                            />
                        </div>
                    </div>
                </GradationButton>
            </div>
            <div>
                <button type="button" className="font-set-sb15 text-gray-desc" onClick={onClickMore}>
                    See more Champion tiers
                </button>
            </div>
        </div>
    );
}
